import { FieldArray } from 'redux-form'
import { length } from 'redux-form-validators'
import { showNoEmoji } from '../../../../../lib/formatter'
import { FormRow, InputCountField } from '../../../../Common/Form'
import { Field } from '../../../../Common/forms'
import { IconPopoverLabel } from '../../../Common/ProposalForm/FormLabelTooltip/FormLabelTooltip'
import { PopoverImg, Tip } from '@vzmi/shp_shared_compo'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'
import { ListingFieldConfig } from '../../../Common/ProposalForm/Shared/FieldConfig'
import { normalizeFeatureTitle } from '../../../Common/ProposalForm/Shared/normalizers'
import SingleLineText from '../../../Common/ReadOnlyComponents/SingleLineText/SingleLineText'
import styles from './index.css'

const ListingDescSection = props => {
  const {
    readOnly
  } = props
  return (
    <>
      {!readOnly &&
        (
          <FormRow>
            <Tip type='info'>
              建議填寫，放入重點關鍵字、相關字、同義字或促銷文字，提示用戶商品優勢。
            </Tip>
          </FormRow>
        )
      }
      <FormRow
        key='featureTitle'
        subTitle='(非必填)'
        className={styles.resetMargin}
        label={(
          <IconPopoverLabel
            popoverContent={(
              <PopoverImg
                url={`${CDN}/img/tooltip_subtitle.png`}
                width={500}
                height={290}
              />
            )}
          >
            特色標題
          </IconPopoverLabel>
        )}
        withInputCountPaddingBottom
      >
        <Field
          name='featureTitle'
          data-role='listing-feature-title'
          component={readOnly ? SingleLineText : InputCountField}
          type='text'
          validate={length({ max: 20 })}
          countLimit={20}
          placeholder='最多20個字元，為求APP呈現最佳化，建議12字以內最佳'
          normalizeOnBlur={normalizeFeatureTitle}
          format={showNoEmoji}
          fullWidth
          showErrorOnActive
          mustShowFormError
          absoluteError
        />
      </FormRow>
      <FormRow
        key='shortDescription'
        label={(
          <IconPopoverLabel
            popoverContent={(
              <PopoverImg
                url={`${CDN}/img/tooltip_feature.png`}
                width={600}
                height={322}
              />
            )}
          >
            商品特色
          </IconPopoverLabel>
        )}
        withInputCountPaddingBottom
        labelAlign='top'
      >
        <FieldArray
          {...ListingFieldConfig.getField('product.shortDescription')}
          name='shortDescription'
          readOnly={readOnly}
          showErrorOnActive
          mustShowFormError
        />
      </FormRow>
      <FormRow
        subTitle='(非必填)'
        label={(
          <IconPopoverLabel
            popoverContent='建立主件商品之料號'
          >
            供應商商品料號
          </IconPopoverLabel>
        )}
      >
        <Field
          {...ListingFieldConfig.getField('model.partNo')}
          name='partNo'
          component={
            readOnly
              ? SingleLineText
              : InputCountField
          }
          fullWidth
          showErrorOnActive
          mustShowFormError
          absoluteError
        />
      </FormRow>
      <FormRow
        label='商品型號'
        subTitle='(非必填)'
        withInputCountPaddingBottom
      >
        <Field
          {...ListingFieldConfig.getField('product.model')}
          name='model'
          component={
            readOnly
              ? SingleLineText
              : InputCountField
          }
          fullWidth
          showErrorOnActive
          mustShowFormError
          absoluteError
        />
      </FormRow>
    </>
  )
}

export default ListingDescSection
